// HTTPBearer may report a missing/invalid Authorization header as 403.
// Real permission denials must keep the session and stay on the current page.
export function isSessionError(error) {
  const status = error.response?.status;
  const detail = error.response?.data?.detail;
  return status === 401 || (status === 403 &&
    (detail === 'Not authenticated' || detail === 'Invalid authentication credentials'));
}

// An old request must never invalidate a token obtained by a later login.
export function shouldInvalidateSession(error, currentToken) {
  const authorization = error.config?.headers?.Authorization;
  return Boolean(currentToken) && isSessionError(error) &&
    authorization === `Bearer ${currentToken}`;
}
